import React from "react";
import { Outlet } from "react-router-dom";


export const VehiclemodelsBase : React.FC = () => {

    return (
        <Outlet />
    )
}